export default "__VITE_ASSET__BVTsWrB9__"